import React from 'react';
import styled, { css } from 'styled-components';
import { Classable, HasChildren, Shapeable, Slice } from '@shapeable/types';
import { breakpoints } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { ExplorerChallengesLayout } from '../explorer/explorer-challenges-layout';
import { usePages } from '@shapeable/ui';

const cls = classNames('slice-explorer-challenges-layout');

// -------- Types -------->

// -------- Props -------->

export type SliceExplorerChallengesLayoutProps = Classable & HasChildren & { 
  entity?: Slice;
};

export const SliceExplorerChallengesLayoutDefaultProps: Omit<SliceExplorerChallengesLayoutProps, 'entity'> = {
};

// -------- Child Component Props -------->

type ContainerProps = {

};

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
  
  `,
});


// -------- Components -------->

const My = {
  Container: styled(ExplorerChallengesLayout)<ContainerProps>`${ContainerStyles}`,
};

export const SliceExplorerChallengesLayout: Shapeable.FC<SliceExplorerChallengesLayoutProps> = (props) => {
  const { className, children, entity } = props;

  const pages = usePages().find(p => p.slug === 'challenges');

  return (
    <My.Container entity={pages} className={cls.name(className)} />
  )
};

SliceExplorerChallengesLayout.cls = cls;
